import { EncryptedXmlOfferRepository, EncryptedXmlOffer } from '@/Domain/XmlOffer/Encrypter'
import { ProcedureId } from '@/Domain/Procedures'
import { AccountId } from '@/Domain/Account'
import { ConcatenatedBatches } from '@/Domain/AuctionA'

async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

const sendOffer = (): string => {
  return 'https://ovmediorural.xunta.gal/es'
}

export class InMemoryEncryptedXmlOfferRepository implements EncryptedXmlOfferRepository {
  // eslint-disable-next-line
  async store (
    // eslint-disable-next-line
    procedureId: ProcedureId,
    // eslint-disable-next-line
    userId: AccountId,
    // eslint-disable-next-line
    concatenatedBatches: ConcatenatedBatches,
    // eslint-disable-next-line
    encryptedXmlOffers: EncryptedXmlOffer[]
  ): Promise<string> {
    const duration = 1000
    await wait(duration)
    return sendOffer()
  }
}
